import { Box } from '@mui/material';
import { useEffect } from 'react';
import { SetValueConfig, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import {
 reportsGenerateStart,
 ReportType,
} from '../../../redux/reports/reportsSlice';
import { RootState } from '../../../redux/store';
import SelectApiManual from '../SelectApiManual';
import { useGridApiContext } from '@mui/x-data-grid-premium';

const ToolbarReports = () => {
 const dispatch = useDispatch();
 const report = useSelector((state: RootState) => state.reports.report);
 const success = useSelector((state: RootState) => state.reports.success);
 const { t } = useTranslation();
 const apiRef = useGridApiContext();
 const { control, setValue, reset } = useForm({
  mode: 'onChange',
 });

 const generateReport = ({
  value,
  type,
 }: {
  value: number;
  type: 'Word' | 'PdfReport';
 }) => {
  const filterItems = apiRef.current.state.filter.filterModel.items;
  const getFilterItemRawValue = (field: string, operator?: string) =>
   filterItems.find(
    (item) => item.field === field && (!operator || item.operator === operator),
   )?.value;
  const getFilterItemValue = (field: string, operator?: string) => {
   const filterValue = getFilterItemRawValue(field, operator);
   if (
    filterValue === undefined ||
    filterValue === null ||
    filterValue === ''
   ) {
    return undefined;
   }
   return String(filterValue);
  };
  const parseNumericFilterValue = (filterValue: unknown) => {
   if (
    filterValue === undefined ||
    filterValue === null ||
    filterValue === ''
   ) {
    return undefined;
   }
   if (
    typeof filterValue === 'object' &&
    filterValue &&
    'Id' in filterValue &&
    (filterValue as { Id?: unknown }).Id !== undefined &&
    (filterValue as { Id?: unknown }).Id !== null &&
    (filterValue as { Id?: unknown }).Id !== ''
   ) {
    const parsedObjectId = Number((filterValue as { Id: unknown }).Id);
    if (!Number.isFinite(parsedObjectId)) {
     return undefined;
    }
    return parsedObjectId;
   }
   const parsedValue = Number(filterValue);
   if (!Number.isFinite(parsedValue)) {
    return undefined;
   }
   return parsedValue;
  };
  const getNumericFilterValue = (fields: string[], operator?: string) => {
   for (const field of fields) {
    const parsedValue = parseNumericFilterValue(
     getFilterItemRawValue(field, operator),
    );
    if (parsedValue !== undefined) {
     return parsedValue;
    }
   }
   return undefined;
  };
  const startDate = getFilterItemValue('Date', 'onOrAfter');
  const endDate = getFilterItemValue('Date', 'onOrBefore');
  const receiverId = getNumericFilterValue([
   'ReceiverId',
   'Receiver.Id',
   'Receiver',
  ]);
  const productId = getNumericFilterValue([
   'ProductId',
   'Product.Id',
   'Product',
  ]);
  const carId = getNumericFilterValue(['CarId', 'Car.Id', 'Car']);
  const driverId = getNumericFilterValue(['DriverId', 'Driver.Id', 'Driver']);
  const productGroupId = getNumericFilterValue([
   'ProductGroupId',
   'ProductGroup.Id',
   'ProductGroup',
  ]);
  const cargoType = getNumericFilterValue(['CargoType']);
  const carrierId = getNumericFilterValue([
   'CarrierId',
   'Carrier.Id',
   'Carrier',
  ]);
  const senderId = getNumericFilterValue(['SenderId', 'Sender.Id', 'Sender']);
  const payload = {
   type,
   ReportTemplateId: value,
   ...(startDate ? { StartDate: startDate } : {}),
   ...(endDate ? { EndDate: endDate } : {}),
   ...(receiverId !== undefined ? { ReceiverId: receiverId } : {}),
   ...(productId !== undefined ? { ProductId: productId } : {}),
   ...(carId !== undefined ? { CarId: carId } : {}),
   ...(driverId !== undefined ? { DriverId: driverId } : {}),
   ...(productGroupId !== undefined ? { ProductGroupId: productGroupId } : {}),
   ...(cargoType !== undefined ? { CargoType: cargoType } : {}),
   ...(carrierId !== undefined ? { CarrierId: carrierId } : {}),
   ...(senderId !== undefined ? { SenderId: senderId } : {}),
  };

  dispatch(reportsGenerateStart(payload));
 };

 useEffect(() => {
  //   console.log('success', success);
  if (success?.reportsGenerate && report) {
   if (report.file && report.type && report.extension && report.name) {
    // this fires from useReportDialog
    // downloadBase64File(report.file, report.name, report.type, report.extension);
    reset();
   }
  }
 }, [success]);

 const handleValueChange = (
  name: string,
  value: ReportType | null,
  options: SetValueConfig,
 ) => {
  setValue(name, value, options);
  if (value) {
   generateReport({
    value: value.Id,
    type: value.Type === 'Word' ? 'Word' : 'PdfReport', // fix it
   });
  }
 };

 return (
  <Box sx={{ width: 200, display: { xs: 'none', md: 'block' } }}>
   <SelectApiManual
    size="small"
    name="ReportTemplateId"
    url="/api/Reports/v1"
    filterVar="Name"
    limit={1000}
    fixedFilters={[
     {
      field: 'DocumentType',
      operator: 'eq',
      value: 'Multi',
     },
    ]}
    isEditable
    label={t('gridToolbar.report')}
    control={control}
    setValue={handleValueChange}
    disabled={false}
   />
  </Box>
 );
};
export default ToolbarReports;
